<template>
    <form  @submit.prevent="submit" id="marketing_tool_form">
    <kt-form-section class="mb-5 mt-3">
        <label class="input-group">
            <h4>
                {{ $t('marketing.marketing_setting.current_banner') }}
            </h4>
        </label>
        <kt-row class="border-bottom">
            <kt-col class="col-lg-6 col-md-4 col-sm-4 border-right">
                <kt-form-group class="mt-lg-4 mt-md-4 mt-sm-3">
                    <kt-form-label>
                        <h4>
                            {{ $t('marketing.marketing_tools.horizental_banner') }}
                        </h4>
                    </kt-form-label>
                    <div class="mt-4 ml-3">
                        <img alt="horizental_banner" id="hor_banner" class="hor_banner" >
                    </div>
                </kt-form-group>
            </kt-col>
            <kt-col class="col-lg-6 col-md-4 col-sm-4">
                <kt-form-group class="mt-lg-4 mt-md-4 mt-sm-3">
                    <kt-form-label>
                        <h4>
                            {{ $t('marketing.marketing_tools.vertical') }}
                        </h4>
                    </kt-form-label>
                    <div class="ml-5">
                        <img  alt="vertical_banner" class="ver_banner" id="ver_banner" >
                    </div>
                </kt-form-group>
            </kt-col>
        </kt-row>

        <kt-form-section class="mt-5">
            <kt-form-label>
                <h4>
                {{ $t('marketing.marketing_setting.change_banner') }}
                </h4>
            </kt-form-label>
            <kt-row>
                <kt-col class="col-lg-6 col-md-6 col-sm-4">
                    <kt-form-group>
                            <kt-form-label>
                                <h6>
                                    {{ $t('marketing.marketing_setting.choose_hor_banner') }}
                                </h6>
                            </kt-form-label>
                            <kt-form-label for="hor_banner_file" class="d-block btn btn-secondary btn-wide label-file">
                                <kt-icon type="fa" name="paperclip"></kt-icon>
                                {{ $t('gateway.btn.click_me') }}
                            </kt-form-label>
                            <input
                                    @change="processHorBannerFile"
                                    type="file"
                                    class="custom-file-upload"
                                    name="hor_banner_file"
                                    id="hor_banner_file"
                                    accept="image/png,.gif,.jpg,.jpeg"
                            />
                        </kt-form-group>
                </kt-col>
                <kt-col class="col-lg-6 col-md-6 col-sm-4">
                    <kt-form-group>
                        <kt-form-label>
                            <h6>
                                {{ $t('marketing.marketing_setting.choose_ver_banner') }}
                            </h6>
                        </kt-form-label>
                        <kt-form-label for="ver_banner_file" class="d-block btn btn-secondary btn-wide label-file">
                            <kt-icon type="fa" name="paperclip"></kt-icon>
                            {{ $t('gateway.btn.click_me') }}
                        </kt-form-label>
                        <input
                                @change="processVerBannerFile"
                                type="file"
                                class="custom-file-upload"
                                name="ver_banner_file"
                                id="ver_banner_file"
                                accept="image/png,.gif,.jpg,.jpeg"
                        />
                    </kt-form-group>
                </kt-col>
            </kt-row>
        </kt-form-section>
            <kt-form-action class="mt-4">
                <kt-button
                        variant="success"
                        type="submit"
                        v-bind:wide="true"
                        id="tool_setting_submit_btn"
                >
                    {{ $t('marketing.marketing_setting.upload') }}
                </kt-button>
            </kt-form-action>
    </kt-form-section>
    </form>
</template>

<script>
import $ from 'jquery'
import { i18n } from '@/plugins/i18n'

export default {
    props: {
        marketing_setting: {
            required: true
        },
        submit: {
            default: () => {},
            type: Function
        },
    },
    mounted() {
        $('#hor_banner').attr('src', this.marketing_setting.hor_banner)
        $('#ver_banner').attr('src', this.marketing_setting.ver_banner)
    },
    methods: {
        processHorBannerFile(e) {
            this.marketing_setting.hor_banner = event.target.files[0]
            this.validateFormat(event.target)
        },
        processVerBannerFile(e) {
            this.marketing_setting.ver_banner = event.target.files[0]
            this.validateFormat(event.target)
        },
        validateFormat(file) {
            let jq_file = $(file);
            let file_name = jq_file.val();
            let extension = file_name.replace(/^.*\./, '');
            if (extension === file_name) {
                extension = '';
            } else {
                extension = extension.toLowerCase();
            }

            switch (extension) {
                case 'jpg':
                case 'jpeg':
                case 'png':
                case 'gif':
                    break;
                default:
                    alert(i18n.t('authenticate.input_format_err'));
                    $(file).val('');
            }
        },
    },

}
</script>

<style>
    .label-file {
        border: 1px solid #ccc;
        width: fit-content;
        cursor: pointer;
        min-width: 200px;
    }
    input[type="file"]::-webkit-file-upload-button {
        visibility: hidden;
    }
    .border-bottom {
        border-bottom: solid;
        border-width: 1px;
    }
    .hor_banner {
        width:200px;
        height:60px
    }
    .ver_banner {
        width:70px;
        height:90px
    }
</style>
